import { Box, Button, CardActions } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import theme from "./../../assets/theme/theme";

export const style = {
  cardActionsRoot: {
    backgroundColor: theme.palette.secondary.main + "!important",
  },
  buttonCancel: {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
};
const useStyles = makeStyles((theme) => style);

const FormButtons = (props) => {
  const classes = useStyles();
  const {
    onClickClose,
    onClickSave,
    unCreatable,
    closeButtonText,
    saveButtonText,
  } = props;
  return (
    <Box
      classes={{ root: classes.cardActionsRoot }}
      component={CardActions}
      justifyContent="flex-end"
    >
      <Button classes={{ root: classes.buttonCancel }} onClick={onClickClose}>
        {closeButtonText}
      </Button>
      <Button
        color="primary"
        variant="contained"
        onClick={onClickSave}
        disabled={unCreatable}
      >
        {saveButtonText}
      </Button>
    </Box>
  );
};

export default FormButtons;
